/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';

import { Table, IconButton as IconButtonWithText, Loader } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';

import { DownloadIcon } from '../../../Components/icons';
import { useExcelDownloder } from '@coinsummer/react-xls';
import moment from 'moment';
import { sosList } from '../../../services/bioplus-services/sos';
import { IntlMessages } from '../../../helper/langHelper';
import { exportExcelFile } from '../../../helper/exportExcelHelper';

function extractData(dataArray) {
  if (dataArray) {
    const extractedData = dataArray?.map((item, index) => {
      return {
        Date: moment(item?.createdAt).format('DD-MM-YYYY'),
        companyName: item.companyName,
        premiseName: item.premiseName,
        geofenceName: item.geofenceName,
        createdAt: moment(item.createdAt).format('HH:mm:ss').toString(),
        OccupantsCount: item?.occupants?.length > 0 ? item?.occupants?.length : 0,
        OccupantsName:
          item?.occupants?.length > 0
            ? item?.occupants?.map((item) => item?.name)?.toString()
            : '...',
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const SOS = () => {
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const { ExcelDownloder, Type } = useExcelDownloder();

  const { userPermission } = userContext;
  const isUserAllowToManage = userPermission?.find((permission) => permission?.label === 'sos');

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const sosQuery = useQuery(['sosList', page, pageSize], () => sosList(page, pageSize));
  const userTableData = sosQuery?.data?.items ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'name',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
      },
      {
        Header: <IntlMessages id="table.col.date" />,
        accessor: 'date',
      },
      {
        Header: <IntlMessages id="table.col.zone" />,
        accessor: 'zone',
        width: '24%',
      },
      {
        Header: <IntlMessages id="table.col.location" />,
        accessor: 'location',
      },
      {
        Header: <IntlMessages id="table.col.emergency.email" />,
        accessor: 'emergencyEmail',
      },
      {
        Header: <IntlMessages id="table.col.emergency.number" />,
        accessor: 'emergencyNumber',
      },
    ],
    []
  );

  const excelFormatData = extractData(sosQuery?.data?.items);
  const fileName = `SOS-${userRole?.companyName}-${moment().format('DD-MM-YYYY-hh.mm A')}.xlsx`;
  const columnConfig = [
    { header: 'Date', key: 'Date', width: 20 },
    { header: 'Entity Name', key: 'companyName', width: 30 },
    { header: 'premise Name', key: 'premiseName', width: 30 },
    { header: 'Geofence Name', key: 'geofenceName', width: 30 },
    { header: 'Created At', key: 'createdAt', width: 20 },
    { header: 'Occupants Count', key: 'OccupantsCount', width: 30 },
    { header: 'Occupants Name', key: 'OccupantsName', width: 30 },
  ];

  if (sosQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.sos" />
        </HeaderTitle>
        {isUserAllowToManage?.isReport && excelFormatData && (
          <IconButtonWithText
            text={<IntlMessages id="button.text.downloadExcel" />}
            icon={<DownloadIcon />}
            onClick={() => exportExcelFile(excelFormatData, fileName, columnConfig)}
          />
        )}
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={userTableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={sosQuery?.data?.length || 0}
        />
      </TableWrapper>
    </StyledContainer>
  );
};

export default SOS;
